import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Invoice.css';
import logoimage from "./assets/logo.gif";

const Invoice = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // State to store input field values
  const [formData, setFormData] = useState({
    agent: '',
    shipping: '',
    departure: '',
    arrival: '',
    document: '',
    infoterm: '',
  });

  useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        const response = await axios.get(`https://api.saadmotors.com/fetch_invoice.php?id=${id}`);
        if (response.data.error) {
          throw new Error(response.data.error);
        }
        setInvoiceData(response.data);
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to load invoice data');
      } finally {
        setLoading(false);
      }
    };

    fetchInvoiceData();
  }, [id]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePreview = () => {
    // Pass both invoiceData and formData to InvoicePreview
    navigate(`/invoice-preview/${id}`, { state: { formData } });
  };

  if (loading) return <div>Loading invoice...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!invoiceData) return <div>No invoice data found for ID: {id}</div>;

  return (
    <div className="invoice-main-container">
      <div className="invoice-main-box">
        <div className="row invoice-main-header">
          <div className='col-sm-2 logobox-main'>
            <img src={logoimage} alt="Logo" className="invoice-main-logo" />
          </div>
          <div className='col-sm-7 titlebox-main'>
            <h2>SAAD MOTORS (THAILAND) CO.,LTD</h2>
            <p>127/2 Kaha Romklao Road, Rat Phatthana Subdistrict, Saphan Sung District, Bangkok 10240, Thailand</p>
            <p>PHONE :+66-92-836-7345</p>
            <p>Invoice for Vehicle ID: {id}</p>
          </div>
          <div className='col-sm-3 detailsbox-main'>
            <h2>PROFORMA INVOICE</h2>
          </div>
        </div>

        <div className="row invoice-main-section">
          <div className='col-sm-7'>
            <h3>CUSTOMER DETAILS</h3>
            <table className="invoice-main-table">
              <tbody>
                <tr>
                  <td><strong> NAME:</strong></td>
                  <td><input type='text' name="client_name" value={formData.client_name} onChange={handleInputChange} /></td>
                </tr>
                <tr>
                  <td><strong> ADDRESS:</strong></td>
                  <td><input type='text' name="client_address" value={formData.client_address} onChange={handleInputChange} /></td>
                </tr>
                <tr>
                  <td><strong>CONTACT:</strong></td>
                  <td><input type='text' name="client_contact" value={formData.client_contact} onChange={handleInputChange} /></td>
                </tr>
                <tr>
                  <td><strong>EMAIL:</strong></td>
                  <td><input type='text' name="client_email" value={formData.client_email} onChange={handleInputChange} /></td>
                </tr>
              </tbody>
            </table>
            <h3>CONSIGNEE & NOTIFY DETAILS</h3>
            <table className="invoice-main-table">
              <tbody>
                <tr>
                  <td><strong> NAME:</strong></td>
                  <td><input type='text' name="consignee_name" value={formData.consignee_name} onChange={handleInputChange} /></td>
                </tr>
                <tr>
                  <td><strong> ADDRESS:</strong></td>
                  <td><input type='text' name="consignee_address" value={formData.consignee_address} onChange={handleInputChange} /></td>
                </tr>
                <tr>
                  <td><strong>CONTACT:</strong></td>
                  <td><input type='text' name="consignee_contact" value={formData.consignee_contact} onChange={handleInputChange} /></td>
                </tr>
                <tr>
                  <td><strong>EMAIL:</strong></td>
                  <td><input type='text' name="consignee_email" value={formData.consignee_email} onChange={handleInputChange} /></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className='col-sm-5'>
            <table className="invoice-main-table">
              <tbody>
                <tr>
                  <td><strong>DATE:</strong></td>
                  <td>{invoiceData.sale_date || 'N/A'}</td>
                </tr>
                <tr>
                  <td><strong>INVOICE #:</strong></td>
                  <td>SN-{invoiceData.id}-{invoiceData.stock_id}</td>
                </tr>
                <tr>
                  <td><strong>CUSTOMER #:</strong></td>
                  <td>{invoiceData.client_id || 'N/A'}</td>
                </tr>
                <tr>
                  <td><strong>AGENT:</strong></td>
                  <td><input type='text' name="agent" value={formData.agent} onChange={handleInputChange} /></td>
                </tr>
                <tr>
                  <td><strong>SHIPPING:</strong></td>
                  <td><input type='text' name="shipping" value={formData.shipping} onChange={handleInputChange} /></td>
                </tr>
                <tr>
                  <td><strong>P.DEPARTURE:</strong></td>
                  <td><input type='text' name="departure" value={formData.departure} onChange={handleInputChange} /></td>
                </tr>
                <tr>
                  <td><strong>P.ARRIVAL:</strong></td>
                  <td><input type='text' name="arrival" value={formData.arrival} onChange={handleInputChange} /></td>
                </tr>
                <tr>
                  <td><strong>COUNTRY:</strong></td>
                  <td>{invoiceData.country || 'N/A'}</td>
                </tr>
                <tr>
                  <td><strong>DOCUMENT:</strong></td>
                  <td><input type='text' name="document" value={formData.document} onChange={handleInputChange} /></td>
                </tr>
                <tr>
                  <td><strong>INFOTERM:</strong></td>
                  <td><input type='text' name="infoterm" value={formData.infoterm} onChange={handleInputChange} /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="bank-main-section">
          <h3>BANKING DETAILS</h3>
          <p>BENEFICIARY BANKING DETAILS (INTERNATIONAL WIRE TRANSFERS)</p>
        </div>

        <div className="bankdeatils-main-section">
          <table className="invoice-table table table-striped">
            <tbody>
              <tr>
                <td><strong>BANK NAME:</strong></td>
                <td>KASIKORN BANK PUBLIC COMPANY</td>
              </tr>
              <tr>
                <td><strong>BENEFICIARY NAME:</strong></td>
                <td>SAAD MOTORS (THAILAND) CO.,LTD</td>
              </tr>
              <tr>
                <td><strong>ACCOUNT NUMBER:</strong></td>
                <td>236-8-38477-4</td>
              </tr>
              <tr>
                <td><strong>BRANCH CODE:</strong></td>
                <td>TESCO LOTUS CHAI 2 (RAMA 2 RD)</td>
              </tr>
              <tr>
                <td><strong>BRANCH NAME:</strong></td>
                <td>SAAD MOTORS CO,. LTD</td>
              </tr>
              <tr>
                <td><strong>BRANCH ADDRESS:</strong></td>
                <td>2 CHOME-10-1 CENTRAL TSUCHIURA</td>
              </tr>
              <tr>
                <td><strong>SWIFT CODE:</strong></td>
                <td>KASITHBK</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="bank-section">
          <h3>INTERMEDIARY BANKING DETAILS</h3>
        </div>

        <div className="bankdeatils-section">
          <table className="invoice-table table table-striped">
            <tbody>
              <tr>
                <td><strong>BANK NAME:</strong></td>
                <td>KASIKORN BANK PUBLIC COMPANY</td>
              </tr>
              <tr>
                <td><strong>BRANCH NAME :</strong></td>
                <td>TESCO LOTUS CHAI 2 (RAMA 2 RD)</td>
              </tr>
              <tr>
                <td><strong>BRANCH ADDRESS:</strong></td>
                <td>99/8 RAMA 2 RD. THA SAI MUANG SAMUT SAKHON 74000</td>
              </tr>
              <tr>
                <td><strong>SWIFT CODE:</strong></td>
                <td>KASITHBK</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="bank-section">
          <h3>VEHICLE DESCRIPTION</h3>
        </div>

        <div className="bankdeatils-section">
          <table className="invoice-table table table-striped">
            <thead>
              <tr>
                <th>QTY</th>
                <th>DESCRIPTION OF GOODS</th>
                <th>DEPOSIT 30%</th>
                <th>BALANCE 70%</th>
                <th>TOTAL CNF DEAL</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{width:"15%"}}>1</td>
                <td style={{width:"35%"}}>
                  <tr>
                    <td><strong>Stock ID:</strong></td>
                    <td>{invoiceData.stock_id || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><strong>Maker:</strong></td>
                    <td>{invoiceData.maker || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><strong>Engine:</strong></td>
                    <td>{invoiceData.engine || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><strong>Color:</strong></td>
                    <td>{invoiceData.color || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><strong>Mileage:</strong></td>
                    <td>{invoiceData.mileage || 'N/A'} km</td>
                  </tr>
                  <tr>
                    <td><strong>Body Type:</strong></td>
                    <td>{invoiceData.body_type || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><strong>Chassis #:</strong></td>
                    <td>{invoiceData.vin || 'N/A'}</td>
                  </tr>
                </td>
                <td style={{width:"15%"}}>USD 0</td>
                <td style={{width:"15%"}}>USD 0</td>
                <td style={{width:"15%"}}>${parseFloat(invoiceData.price || 0).toFixed(2)}</td>
              </tr>
              <tr>
                <td colspan="2">
                  Customer
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td colspan="2"><strong>GRAND TOTAL</strong></td>
                <td><strong>USD 0</strong></td>
                <td><strong>USD 0</strong></td>
                <td><strong>${parseFloat(invoiceData.price || 0).toFixed(2)}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="invoice-main-actions">
          <button onClick={handlePreview} className="preview-btn">
            Preview
          </button>
        </div>
      </div>
    </div>
  );
};

export default Invoice;